function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../../../../customer/components";
import { ExpertEscalationReviewSummary, getReviewSummaryDialogueText } from "../../../../../expert";
import { PortalButton } from "../../../..";
import ConversationPanelFooter from "../conversation-panel-footer/ConversationPanelFooter";
import PanelHeader from "../../panel-header/PanelHeader";
import ReviewSummary from "../../review-summary/ReviewSummary";
import ConversationTabContent from "../conversation-tab-content/ConversationTabContent";
const ConversationReviewPanel = ({
  t,
  classes
}) => {
  return /*#__PURE__*/React.createElement(ExpertEscalationReviewSummary, null, ({
    escalationReviewState,
    onEscalationAgree,
    onEscalationDisagree,
    onFormSubmit,
    defaultSummaryLabel,
    noOfDialoguesVoted,
    ...rest
  }) => {
    let reviewSummaryLabel = defaultSummaryLabel;
    let isDisagree = false;
    if (escalationReviewState) {
      reviewSummaryLabel = t("You {0} this conversation should be forwarded", escalationReviewState);
      isDisagree = escalationReviewState === "disagree";
    }
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(PanelHeader, null, /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary",
      variant: "subtitle1"
    }, t("Forward Review"))), /*#__PURE__*/React.createElement(ConversationTabContent, null, /*#__PURE__*/React.createElement("div", {
      className: classes.escalationReviewPanelContainer
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary"
    }, t("A fellow ambassador believes that this conversation cannot be answered and should be forwarded back to the client. Do you agree?")), /*#__PURE__*/React.createElement("div", {
      className: classes.voteButtonContainer
    }, /*#__PURE__*/React.createElement(PortalButton, {
      onClick: onEscalationAgree,
      id: "agreeEscalationButton",
      variant: escalationReviewState === "agree" ? "contained" : "outlined"
    }, "Yes"), /*#__PURE__*/React.createElement(PortalButton, {
      onClick: onEscalationDisagree,
      id: "disagreeEscalationButton",
      variant: isDisagree ? "contained" : "outlined"
    }, "No")), /*#__PURE__*/React.createElement(ReviewSummary, {
      t: t
    }, reviewSummaryLabel, " ", isDisagree && t(getReviewSummaryDialogueText(noOfDialoguesVoted), noOfDialoguesVoted)))), /*#__PURE__*/React.createElement(ConversationPanelFooter, _extends({
      onFinish: onFormSubmit,
      finishTooltip: "You must agree, vote or send a reply to finish this review",
      cancelTooltip: ""
    }, rest)));
  });
};
const styles = () => ({
  escalationReviewPanelContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: 16
  },
  voteButtonContainer: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: 16,
    marginBottom: 16
  }
});
export default withStyles(styles)(withi18n(ConversationReviewPanel));
ConversationReviewPanel.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
};